const messages = {
  WITHDRAWAL_ALREADY_PENDING: 'มีรายการถอนที่กำลังดำเนินการอยู่ กรุณาตรวจสอบประวัติรายการหรือติดต่อเจ้าหน้าที่',
  REVIEW_REQUIRED: 'คำขอถอนนี้อยู่ระหว่างตรวจสอบ กรุณารอเจ้าหน้าที่ยืนยันผลก่อนทำรายการใหม่',
  WITHDRAWAL_REVIEW_REQUIRED: 'คำขอถอนนี้อยู่ระหว่างตรวจสอบ กรุณารอเจ้าหน้าที่ยืนยันผลก่อนทำรายการใหม่',
  INSUFFICIENT_CREDIT: 'ยอดเงินไม่เพียงพอ กรุณาตรวจสอบยอดเงินอีกครั้ง',
  DAILY_WITHDRAWAL_LIMIT: 'จำนวนเงินถอนเกินวงเงินคงเหลือประจำวัน กรุณาตรวจสอบยอดถอนในประวัติรายการ',
  BONUS_TURNOVER_REQUIRED: 'ยอดเทิร์นยังไม่ครบตามเงื่อนไขโบนัส กรุณาตรวจสอบเงื่อนไขก่อนถอนเงิน',
  BALANCE_UNAVAILABLE: 'ระบบยังตรวจสอบยอดเงินไม่ได้ กรุณารอสักครู่แล้วตรวจสอบรายการเดิมอีกครั้ง',
  INVALID_AMOUNT: 'กรุณาระบุจำนวนเงินที่ถูกต้อง โดยถอนขั้นต่ำ 100 บาท',
  WITHDRAWAL_REQUEST_CONFLICT: 'ข้อมูลคำขอถอนเดิมไม่ตรงกัน กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบรายการ',
  WITHDRAWAL_UNCERTAIN_AMOUNT: 'ยังยืนยันผลคำขอถอนก่อนหน้าไม่ได้ กรุณาใช้จำนวนเงินเดิมเพื่อตรวจสอบผล หรือติดต่อเจ้าหน้าที่',
  WITHDRAWAL_STORAGE_UNAVAILABLE: 'ไม่สามารถบันทึกคำขอถอนบนอุปกรณ์นี้ได้ กรุณาตรวจสอบการตั้งค่าเบราว์เซอร์แล้วลองใหม่',
  AUTH_REQUIRED: 'กรุณาเข้าสู่ระบบใหม่ก่อนทำรายการถอน',
  INVALID_SESSION: 'กรุณาเข้าสู่ระบบใหม่ก่อนทำรายการถอน',
  MEMBER_SESSION_REQUIRED: 'กรุณาเข้าสู่ระบบใหม่ก่อนทำรายการถอน',
  MEMBER_ACCESS_DENIED: 'ไม่สามารถใช้บัญชีนี้ทำรายการได้ กรุณาติดต่อเจ้าหน้าที่',
  MEMBER_DISABLED: 'ไม่สามารถใช้บัญชีนี้ทำรายการได้ กรุณาติดต่อเจ้าหน้าที่'
}

const definiteRejections = new Set([
  'INSUFFICIENT_CREDIT', 'DAILY_WITHDRAWAL_LIMIT', 'BONUS_TURNOVER_REQUIRED',
  'BALANCE_UNAVAILABLE', 'INVALID_AMOUNT', 'AUTH_REQUIRED', 'INVALID_SESSION',
  'MEMBER_SESSION_REQUIRED', 'MEMBER_ACCESS_DENIED', 'MEMBER_DISABLED'
])
const accountRejections = new Set(['AUTH_REQUIRED', 'INVALID_SESSION', 'MEMBER_SESSION_REQUIRED', 'MEMBER_ACCESS_DENIED', 'MEMBER_DISABLED'])

export function withdrawalFailureCode (error) {
  const data = error && error.response && error.response.data
  const candidates = [data && data.code, data && data.message, data && data.error, error && error.code, error && error.message]
  for (const candidate of candidates) {
    const values = Array.isArray(candidate) ? candidate : [candidate]
    for (const value of values) if (typeof value === 'string' && Object.prototype.hasOwnProperty.call(messages, value)) return value
  }
  return ''
}

export function withdrawalErrorMessage (error) {
  const code = withdrawalFailureCode(error)
  if (code) return messages[code]
  const status = error && error.response && error.response.status
  if (status === 401) return messages.INVALID_SESSION
  if (status === 403) return messages.MEMBER_ACCESS_DENIED
  return 'ยังยืนยันผลคำขอถอนเงินไม่ได้ กรุณาตรวจสอบประวัติรายการก่อนทำรายการใหม่ หรือติดต่อเจ้าหน้าที่'
}

export function isDefiniteWithdrawalRejection (error, priorUncertain = false) {
  const response = error && error.response
  // A lost response or server failure can follow a debit; retain the original request ID.
  if (!response || response.status >= 500 || response.status === 409) return false
  if (response.status >= 200 && response.status < 300 && (!response.data || response.data.status !== false)) return false
  const code = withdrawalFailureCode(error)
  // Authentication failure cannot resolve an earlier request whose result was lost.
  if (priorUncertain && (response.status === 401 || response.status === 403 || accountRejections.has(code))) return false
  return definiteRejections.has(code) || response.status === 401 || response.status === 403
}

function attemptStorageKey (key) { return 'xxmac:withdrawal-attempt:' + key }

export function readWithdrawalAttempt (key) {
  try {
    const raw = localStorage.getItem(attemptStorageKey(key))
    if (!raw) return null
    const attempt = JSON.parse(raw)
    if (!attempt || !Number.isFinite(attempt.amount) || attempt.amount < 100 || !/^[A-Za-z0-9_-]{8,100}$/.test(attempt.requestId || '')) throw new Error('INVALID_ATTEMPT')
    return attempt
  } catch (_) {
    throw new Error('WITHDRAWAL_STORAGE_UNAVAILABLE')
  }
}

export function rememberWithdrawalAttempt (key, attempt) {
  try { localStorage.setItem(attemptStorageKey(key), JSON.stringify(attempt)) }
  catch (_) { throw new Error('WITHDRAWAL_STORAGE_UNAVAILABLE') }
}

export function clearWithdrawalAttempt (key) {
  // Keeping an already resolved ID if storage is unavailable is safer than submitting a new ID.
  try { localStorage.removeItem(attemptStorageKey(key)) } catch (_) { /* Keep the previous request. */ }
}
